import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import invoiceApi from 'api/invoiceApi'
import TvanHandleApi from 'api/TvanHandleApi'
import { showNotification } from 'app/appSlice'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import _ from 'lodash'

const keyFactory = {
  base: { scope: ['invoice', 'listIssuedTicket'] },
  lists: () => ({
    ...keyFactory.base,
    entity: 'invoice',
  }),
  pullMessages: () => ({
    ...keyFactory.base,
    entity: 'taxAuthorityMessages',
  }),
}

export const useQueryListInvoice = (filterParams) => {
  const toTableData = (row, idx) => ({
    ...row,
    id: idx + 1,
    no: row?.no ? InvoiceHelper.padNumber(row.no, 8) : null,
    messageId: row.messageId,
  })

  const queryResult = useQuery({
    queryKey: keyFactory.lists(filterParams),
    queryFn: () =>
      TvanHandleApi.getListInvoice({
        ...filterParams,
      }),
    select: (res) => ({
      total: _.get(res?.metadata, 'count', 0),
      tableData: !res?.metadata?.rows
        ? []
        : _.map(res.metadata?.rows, toTableData),
      copyData: _.get(res?.metadata, 'invoiceIdsCopy', []),
      statistics: _.get(res, 'statistics', {}),
    }),
  })
  const { data, isLoading, isFetching, refetch } = queryResult
  return {
    invoiceListData: data?.tableData,
    copyData: data?.copyData,
    isGettingListData: isLoading,
    isRefetchingListData: isFetching,
    refetchListInvoice: refetch,
    ...queryResult,
  }
}

export const useMutationPullBulkMessage = () => {
  const dispatch = useAppDispatch()
  const queryClient = useQueryClient()
  const filterParams = useAppSelector((s) => s.filter.TvanHandle)
  return useMutation({
    mutationKey: keyFactory.pullMessages(),
    mutationFn: ({ startDate, endDate }) =>
      TvanHandleApi.tvanCheckMessages({
        startDate,
        endDate,
        isCompany: false,
      }),
    onError: (err) => console.error(err.message),
    onSuccess: (res) => {
      console.log('response when pull messages sucessfully', res)
      let describeText = `Kiểm tra mã thành công cho ${res?.count} hóa đơn.`
      dispatch(showNotification({ describeText }))
      queryClient.invalidateQueries(
        keyFactory.lists('', { ...filterParams, page: 1 }),
      )
    },
  })
}

export const useQueryListCompany = (filterParams) => {
  const toTableData = (row, idx) => ({
    ...row,
    id: idx + 1,
    no: row?.no ? InvoiceHelper.padNumber(row.no, 8) : null,
    messageId: row.messageId,
  })

  const queryResult = useQuery({
    queryKey: keyFactory.lists(filterParams),
    queryFn: () =>
      TvanHandleApi.getListCompany({
        ...filterParams,
      }),
    select: (res) => {
      return {
        total: res?.result?.total ?? 0,
        tableData: res?.result?.rows ?? [],
        companyConfigs: res?.result?.companyConfigs ?? [],
      }
    },
  })

  const { data, isLoading, isFetching, refetch } = queryResult
  return {
    invoiceListData: data?.tableData,
    total: data?.total,
    copyData: data?.copyData,
    companyConfigs: data?.companyConfigs,
    isGettingListData: isLoading,
    isRefetchingListData: isFetching,
    refetchListInvoice: refetch,
    ...queryResult,
  }
}

export const useQueryListAccountingDocument = (filterParams) => {
  const toTableData = (row, idx) => ({
    ...row,
    id: idx + 1,
    no: row?.no ? InvoiceHelper.padNumber(row.no, 8) : null,
    messageId: row.messageId,
  })

  const queryResult = useQuery({
    queryKey: keyFactory.lists(filterParams),
    queryFn: () =>
      TvanHandleApi.getAccountingDocuments({
        ...filterParams,
      }),
    select: (res) => {
      console.log('res', res)
      return {
        total: res?.totalItems ?? 0,
        tableData: res?.items ?? [],
      }
    },
  })

  const { data, isLoading, isFetching, refetch } = queryResult
  return {
    listData: data?.tableData,
    total: data?.total,
    copyData: data?.copyData,
    companyConfigs: data?.companyConfigs,
    isGettingListData: isLoading,
    isRefetchingListData: isFetching,
    refetchListInvoice: refetch,
    ...queryResult,
  }
}

export const useQueryListPartner = (filterParams) => {
  const queryResult = useQuery({
    queryKey: keyFactory.lists(filterParams),
    queryFn: () =>
      TvanHandleApi.getPartner({
        ...filterParams,
      }),
    select: (res) => {
      console.log('res', res)
      return {
        total: res?.totalItems ?? 0,
        tableData: res?.items ?? [],
        infotPartners: res?.infotPartners ?? [],
      }
    },
  })

  const { data, isLoading, isFetching, refetch } = queryResult
  return {
    listData: data?.tableData,
    total: data?.total,
    copyData: data?.copyData,
    companyConfigs: data?.companyConfigs,
    isGettingListData: isLoading,
    isRefetchingListData: isFetching,
    infotPartners: data?.infotPartners ?? [],
    refetchListInvoice: refetch,
    ...queryResult,
  }
}
